import * as Yup from 'yup';
import { STRINGS } from './';

export const CONSTANTS = {
  STATUS_CODES: {
    SUCCESS: 200,
    FORBIDDEN: 403
  },
  ROUTES: {
    PUBLIC_ROUTES: {
      LOGIN: '/login',
      REGISTER: '/register',
      NOT_FOUND: '/404'
    },
    PRIVATE_ROUTES: {
      ACCOUNT: '/app/account',
      EDIT_PROFILE: '/app/account/edit',
      CHANGE_PASSWORD: '/app/account/change-password',
      MEMBERS: '/app/members',
      ADD_MEMBER: '/app/members/add',
      TRAINER: '/app/trainer',
      DIET_PLAN: '/app/diet-plan',
      MEMBERSHIP_PLAN: '/app/membership',
      ADD_TRAINER: '/app/trainer/add',
      ADD_DIET_PLAN: '/app/diet-plan/add',
      ADD_MEMBERSHIP_PLAN: '/app/membership/add',
      EDIT_MEMBER: '/app/members/edit',
      EDIT_TRAINER: '/app/trainer/edit',
      EDIT_DIET_PLAN: '/app/diet-plan/edit',
      EDIT_MEMBERSHIP_PLAN: '/app/membership/edit',
      DASHBOARD: '/app/dashboard',
      MESSAGE: '/app/message',
      ADD_MESSAGE: '/app/message',
      RECORDS: '/app/records',
      QUERIES: '/app/queries',
      EARNINGS: '/app/earnings',
      QUERIES_FOLLOWUPS: '/app/queries-follow-ups',
      ADD_QUERY: '/app/queries/add',
      SETTINGS: '/app/settings',
      DELETE_ADMIN: '/app/deleteAdmin',
      BATCHES: '/app/batches',
      ADD_BATCH: '/app/batches/add',
      EDIT_BATCH: '/app/batch/edit',
      PAYMENT: '/app/payment',
      EDIT_PAYMENT: '/app/payment/edit',
      ADD_PAYMENT: '/app/payment/add',
      PENDING_PAYMENT: '/app/pendingpayments',
      THIS_MONTH_MEMBERSHIP: '/app/this-month-membership',
      MEMBERSHIP_EXPIRED_THIS_MONTH: '/app/membership-expired-this-month',
      ANNIVESARIES: '/app/annivesaries',
      EXPIRED_MEMBERSHIP: '/app/expired-membership',
      ALL_GYMS: '/app/gym'
    }
  },
  memberValidationSchema: Yup.object().shape({
    email: Yup.string()
      .email('Must be a valid email')
      .max(255)
      .required('Email is required'),
    name: Yup.string()
      .min(2)
      .required('Name is required')
      .matches(/^[a-zA-Z]/, 'Name must contains only alphabets.'),
    fatherName: Yup.string()
      .min(2)
      .required('Father name is required')
      .matches(/^[a-zA-Z]/, 'Name must contains only alphabets.'),
    mobileNumber: Yup.string()
      .required('Mobile number is required')
      .min(6, STRINGS.INVALID_PHONE_NUMBER)
      .max(16, STRINGS.INVALID_PHONE_NUMBER),
    gender: Yup.string().required('Gender is required'),
    
    membershipPlan: Yup.string().required('Membership Plan is required'),
    trainer: Yup.string().required('Trainer is required'),
    remarks: Yup.string().required('Remarks is required'),
    height: Yup.number().required('Height is required'),
    weight: Yup.number().required('Weight is required'),
    batch: Yup.string().required('Batch is required'),
    dietplan: Yup.string().required('Diet Plan is required'),
    membershipStartDate: Yup.date().required(
      'Please add membership start date'
    ),
    dateOfBirth: Yup.date().required(
      'Date of birth is required'
    ),
    membershipEndDate: Yup.date()
      .required('Please add membership end date')
      .min(
        Yup.ref('membershipStartDate'),
        'end date must be greater than membership start date'
      ),
    paymentReminderDay: Yup.string().required('Please add Payment Reminder day')
  }),
  trainerValidationSchema: Yup.object().shape({
    name: Yup.string()
      .min(2)
      .required('Name is required')
      .matches(/^[a-zA-Z]/, 'Name must contains only alphabets.'),
    gender: Yup.string().required('Gender is required'),
    address: Yup.string().min(5).required('Address is required'),
    experience: Yup.number().required('Experience is required'),
    mobileNumber: Yup.string()
      .min(6, STRINGS.INVALID_PHONE_NUMBER)
      .max(16, STRINGS.INVALID_PHONE_NUMBER)
  }),
  batchValidationSchema: Yup.object().shape({
    name: Yup.string()
      .min(2)
      .required('Name is required')
      .matches(/^[a-zA-Z]/, 'Name must contains only alphabets.'),
    start_time: Yup.string().required('Start Time is required'),
    end_time: Yup.string().required('End Time is required')
  }),
  gymValidationSchema: Yup.object().shape({
    name: Yup.string()
      .min(2)
      .required('Name is required')
      .matches(/^[a-zA-Z]/, 'Name must contains only alphabets.'),
    address: Yup.string().required('Address is required'),
    phone: Yup.string().required('Contact is required'),
    email: Yup.string()
      .email('Must be a valid email')
      .max(255)
      .required('Email is required')
  }),
  mealValidationSchema: Yup.object().shape({
    food: Yup.string().required('Food is required'),
    quantity: Yup.number().required('Quantity is required'),
    time: Yup.string().required('Time is required')
  }),
  dietValidationSchema: Yup.object().shape({
    name: Yup.string().required('Name is required'),
    diet: Yup.string().required('Diet is required'),
    comments: Yup.string().required('Comments are required'),
    meals: Yup.array().min(1).required('Meals are required'),
    prescribed_by: Yup.string().required('Prescribed by is required')
  }),

  membershipPlanValidationSchema: Yup.object().shape({
    name: Yup.string()
      .min(2)
      .required('Name is required')
      .matches(/^[a-zA-Z]/, 'Name must contains only alphabets.'),
    amount: Yup.number().required('Amount is required'),
    duration: Yup.number().required('Duration is required'),
    description: Yup.string().required('Description is required')
  }),
  registerPaymentScheme: Yup.object().shape({
    amount: Yup.number().required('Amount is required'),
    payment_for_this_month: Yup.string().required(
      'Please enter payment for this month'
    ),
    payment_received_on: Yup.string().required(
      'Please enter payment received on'
    ),
    mode_of_payment: Yup.number().required('Please enter mode of payment')
  }),
  PHONE_REGEX:
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
};
